import React from 'react'
import './skills.css'
import SkillsBars from './skillsbars'

const Skills = () => {
  return (
    <section id="skills">
        <h2 className="skillsTitle">My Skills</h2>
        <span className="skillDesc">I take pride in paying attention to the smallest details. </span>
        <SkillsBars />
    </section>
  )
}

export default Skills
